import { SVGProps, Ref, forwardRef } from 'react';

export const BellOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m17.744 23-2.843-1.652c-.952 1.256-2.262 1.97-3.97 1.513-2.418-.648-2.97-2.934-2.65-5.36L1.5 13.559c.007-.012 8.954-16.598 17.5-11.63C27.55 6.896 17.745 23 17.745 23m-7.742-4.5c-.016.478.022.908.114 1.274.181.726.538 1.15 1.281 1.348.78.21 1.427-.096 1.931-.689zm-6.03-5.586 13.091 7.608c1.126-2.145 2.099-4.384 2.79-6.708.66-2.217 1.01-4.418.773-6.268-.228-1.778-.976-3.159-2.53-4.062-1.552-.901-3.105-.862-4.74-.175-1.705.716-3.421 2.119-4.998 3.802-1.66 1.771-3.103 3.745-4.387 5.803"
            fill="currentColor"
        />
    </svg>
));
BellOutlinedSize24Glyph.displayName = 'BellOutlinedSize24Glyph';
